import Spinner from '@rio-cloud/rio-uikit/Spinner';
import type { JSX } from 'react';

export const LoadingIndicator = (): JSX.Element => (
    <div data-testid='loading-spinner' className='display-flex justify-content-center'>
        <Spinner />
    </div>
);
